import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { PopsySkeletonComponent } from '../skeleton/popsy-skeleton.component';
import { NgIf } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  selector: 'popsy-checkbox',
  templateUrl: './popsy-checkbox.template.html',
  styleUrls: ['./popsy-checkbox.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, PopsySkeletonComponent, A11yModule],
})
export class PopsyCheckboxComponent {
  @Input() public text?: string | null = null;
  @Input() public optionText?: string | null = null;
  @Input('aria-label') public ariaLabel?: string | null = null;
  @Input() public disabled?: boolean | null = null;
  @Input() public loading?: boolean | null = null;
  @Input() public checked?: boolean | null = null;
  @Input() public mobileMode?: boolean | null = null;
  @Input() public boldLabel?: boolean | null = null;
  @Input() public focus?: boolean | null = null;

  @Output() public readonly valueChange: EventEmitter<boolean>;

  constructor() {
    this.valueChange = new EventEmitter();
  }

  public onChange(): boolean {
    this.checked = Boolean(!this.checked);
    this.valueChange.next(this.checked);
    return false;
  }

  public get isChecked(): boolean {
    return Boolean(this.checked);
  }

  public get isDisabled(): boolean {
    return Boolean(this.disabled);
  }
}
